module.exports = __webpack_public_path__ + "img/logo-horizontal-orange-white.9854440b.png";